import {Injectable} from '@angular/core';

import {AngularFireAuth} from 'angularfire2/auth';
import {Http, Headers, RequestOptions} from '@angular/http';

import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {apiUrl} from '../../config/api.config';


@Injectable()
export class RestApiOrganizationService {
  baseUrl = (apiUrl);

  constructor(private http: Http,
              private afAuth: AngularFireAuth) {
  }


  /**
   * Get API TOKEN
   * @returns {Observable<any>}
   */
  private getToken() {
    return this.fromFirebaseAuthPromise(this.afAuth.auth.currentUser.getIdToken());
  }


  /**
   * Update Password Firebase Auth User Object
   * @param uid
   * @param password
   * @returns {Observable<any>}
   */
  deleteOrganization(org_id): Observable<any> {
    return this.getToken()
      .switchMap(res => {
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + res);
        headers.append('Content-Type', 'application/json');

        const options = new RequestOptions({headers: headers});
        const body = ({
          org_id: org_id,
        });
        return this.http
          .post(this.baseUrl + 'disableOrganizationAccount', body, options)
          .map(response => response.json());
      });
  }




  /**
   * Update Password Firebase Auth User Object
   * @param uid
   * @param password
   * @returns {Observable<any>}
   */
  updateUserPassword(formValue): Observable<any> {
    return this.getToken()
      .switchMap(res => {
        const headers = new Headers();
        headers.append('Authorization', 'Bearer ' + res);
        headers.append('Content-Type', 'application/json');

        const options = new RequestOptions({headers: headers});
        const body = ({
          previousPassword: formValue.previousPassword,
          password: formValue.password,
        });
        return this.http
          .post(this.baseUrl + 'updateUserPasswordWithCheck', body, options)
          .map(response => response.json());
      });
  }






  /**
   * Convert Promise of Firebase to an Observable
   * @param promise
   * @returns {Observable<any>}
   */
  private fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/rest-api/organization.service.ts